'use strict';

$ = jQuery;

//dispara eventos de leads de oferta enviados com erro
function send_offer_lead_error_events() {
  send_lead_error_gtm_event();
  gtm_send_lead_error('Oferta', $('.jc-offer-header').data('name'));
  send_data_layer_estadao_lead_error_event();
}

//dispara eventos de leads de oferta enviados com sucesso
function send_offer_lead_success_events(offerID, leadID, context) {
  send_lead_saved_gtm_event();
  send_lead_tracking_event();
  return Promise.all([gtm_get_data_and_send_lead_saved(leadID, context), send_data_layer_estadao_offer_lead_event(offerID)]);
}

//obtem o array de produtos com as caracteristicas da oferta
function get_estadao_offer_product() {
  var offer = $('.jc-offer-header');
  var products = [{
    'brand': offer.data('brand'),
    'id': offer.data('id'),
    'model': offer.data('model'),
    'version': offer.data('version'),
    'category': offer.data('category'),
    'price': 0,
    'year': offer.data('year'),
    'gas': offer.data('gas'),
    'transmission': offer.data('transmission'),
    'doors': offer.data('doors')
  }];
  return products;
}

//dispara eventos de leads pro GTM do Estadao
function send_data_layer_estadao_offer_lead_event(offerID) {

  return new Promise(function (resolve, reject) {
    getOfferEventsData(offerID).then(function (data) {
      send_data_layer_estadao_lead_event(data.products);
      resolve();
    });
  });
}

function getOfferEventsData(offerID) {

  return new Promise(function (resolve, reject) {

    $.ajax({
      url: ajaxHandler.url,
      type: 'POST',
      data: {
        action: 'jc_ajax_offer_data_events',
        offerID: offerID
      },
      success: function success(response) {
        if (response && response.success) {
          resolve(response.data);
        }
      }
    });
  });
}

//dispara eventos de preenchimento de campos do formulário de ofertas
function send_offer_form_steps_events(offerID) {

  var stepsForm = { 'name': false, 'email': false, 'phone': false, 'cpfcnpj': false, 'cep': false, 'city': false, 'dealership': false, 'message': false };
  var stepsMapField = { 'name': 1, 'email': 2, 'phone': 3, 'cpfcnpj': 4, 'cep': 5, 'city': 6, 'dealership': 7, 'message': 8 };

  var formElement = $('#form-offer-' + offerID);

  var title = null;
  var url = null;
  var products = null;

  getOfferEventsData(offerID).then(function (data) {
    title = data.title;
    url = data.url;
    products = data.products;
    formFieldsEvents();
  });

  var formFieldsEvents = function formFieldsEvents() {

    formElement.on('focusout', '.name', function (e) {
      if ($(e.currentTarget).val() != '') {
        pushCompleteStep('name');
      }
    });

    formElement.on('focusout', '.email', function (e) {
      if ($(e.currentTarget).val() != '' && validateEmail($(e.currentTarget).val())) {
        pushCompleteStep('email');
      }
    });

    formElement.on('focusout', '.phone', function (e) {
      if ($(e.currentTarget).val() != '' && validatePhone($(e.currentTarget).val())) {
        pushCompleteStep('phone');
      }
    });

    formElement.on('focusout', '.cpfcnpj', function (e) {
      if ($(e.currentTarget).val() != '' && validateCpfCnpj($(e.currentTarget).val())) {
        pushCompleteStep('cpfcnpj');
      }
    });

    formElement.on('focusout', '.cep', function (e) {
      if ($(e.currentTarget).val() != '' && validateCep($(e.currentTarget).val())) {
        pushCompleteStep('cep');
      }
    });

    formElement.on('change', '.city', function () {
      pushCompleteStep('city');
    });

    formElement.on('change', '.dealerships', function () {
      pushCompleteStep('dealership');
    });

    formElement.on('focusout', '.message', function (e) {
      if ($(e.currentTarget).val() != '') {
        pushCompleteStep('message');
      }
    });
  };

  var pushCompleteStep = function pushCompleteStep(field) {

    if (!stepsForm[field]) {

      stepsForm[field] = true;

      dataLayer.push({
        'event': 'VirtualPageview',
        'virtualPageURL': url,
        'virtualPageTitle': title
      });

      gtag('event', 'VirtualPageview', {
        'virtualPageURL': url,
        'virtualPageTitle': title
      });

      dataLayer.push({
        'event': 'ga_event',
        'eventCategory': 'Oferta',
        'eventAction': 'Preenchimento - Campo',
        'eventLabel': field
      });

      gtag('event', 'Oferta', {
        'eventAction': 'Preenchimento - Campo',
        'eventLabel': field
      });

      dataLayerEstadao.push({
        'event': 'forcePvCheckout',
        'page': '/passo' + stepsMapField[field] + '_' + field,
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': stepsMapField[field], 'option': '' },
            'products': products
          }
        }
      });

      gtag('event', 'forcePvCheckout', {
        'page': '/passo' + stepsMapField[field] + '_' + field,
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': stepsMapField[field], 'option': '' },
            'products': products
          }
        }
      });

      dataLayerEstadao.push({
        'event': 'genericEvent',
        'genericCategory': 'conversao',
        'genericAction': 'lead',
        'genericLabel': field + '_preenchido'
      });

      gtag('event', 'conversao', {
        'genericAction': 'lead',
        'genericLabel': field + '_preenchido'
      });
    }
  };
}

//Função que captura clique nos telefones das concessionárias de uma oferta e dispara o evento de clique
$('.jc-offer-dealership-phones').on('click', function () {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oferta',
    'eventAction': 'Clique - Telefone',
    'eventLabel': $(this).siblings('.jc-offer-dealership').text() + ' - ' + $(this).attr('data-phone')
  });

  gtag('event', 'Oferta', {
    'eventAction': 'Clique - Telefone',
    'eventLabel': $(this).siblings('.jc-offer-dealership').text() + ' - ' + $(this).attr('data-phone')
  });
});

//Exclusivo para telefone 0800 da Mit
$('.offer-phone-mit').on('click', function () {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oferta',
    'eventAction': 'Clique - Telefone',
    'eventLabel': $(this).attr('data-phone')
  });

  gtag('event', 'Oferta', {
    'eventAction': 'Clique - Telefone',
    'eventLabel': $(this).attr('data-phone')
  });
});